var exports = {
  "zp": "LinkedAccountsTab.module__spinnerWrapper___ZGc2VU",
  "p$": "LinkedAccountsTab.module__emptyState___ZGc2VU",
  "G$": "LinkedAccountsTab.module__platformRow___ZGc2VU",
  "h5": "LinkedAccountsTab.module__platformIconButton___ZGc2VU",
  "_4": "LinkedAccountsTab.module__domainIcon___ZGc2VU",
  "eF": "LinkedAccountsTab.module__connectionsList___ZGc2VU",
  "Nr": "LinkedAccountsTab.module__card___ZGc2VU",
  "wy": "LinkedAccountsTab.module__cardDragging___ZGc2VU",
  "V7": "LinkedAccountsTab.module__cardDragHandle___ZGc2VU",
  "EF": "LinkedAccountsTab.module__cardIconSquircle___ZGc2VU",
  "Bj": "LinkedAccountsTab.module__cardInfo___ZGc2VU",
  "_O": "LinkedAccountsTab.module__cardName___ZGc2VU",
  "SI": "LinkedAccountsTab.module__cardNameRow___ZGc2VU",
  "vN": "LinkedAccountsTab.module__verificationBadge___ZGc2VU",
  "eB": "LinkedAccountsTab.module__cardActions___ZGc2VU",
  "hP": "LinkedAccountsTab.module__actionButton___ZGc2VU",
  "Il": "LinkedAccountsTab.module__dropIndicatorTop___ZGc2VU",
  "Yc": "LinkedAccountsTab.module__dropIndicatorBottom___ZGc2VU",
};

module.exports = exports;
